<script setup lang="ts">
import useUserService from '@/composables/apiServices/useUserService';
import { useI18n } from 'vue-i18n';
import { VIcon } from 'vuetify/components';

const { t } = useI18n();

const { attributes, updateAttributes } = useUserService();
const { data: userAttributes } = attributes();
const { mutateAsync: updateUserAttributes } = updateAttributes();

const handleToggleUnread = () => {
  if (!userAttributes.value) {
    throw new Error('User attributes are not loaded');
  }
  updateUserAttributes({
    unreadFolderFilterToggled: !userAttributes.value.unreadFolderFilterToggled
  });
};
</script>

<template>
  <v-tooltip
    :text="
      userAttributes?.unreadFolderFilterToggled
        ? t('foldersUnreadToggle.disable')
        : t('foldersUnreadToggle.enable')
    "
  >
    <template #activator="{ props: tooltipActivatorProps }">
      <TextBtn
        sentry-unmask
        icon="mdi-currency-eth"
        data-test-id="folders-unread-toggle"
        rounded
        size="40"
        v-bind="{ ...tooltipActivatorProps }"
        @click.prevent="handleToggleUnread"
      >
        <v-icon
          color="alert-close"
          size="large"
          :class="{
            'mdi-rotate-180': userAttributes?.unreadFolderFilterToggled
          }"
        >
          mdi-filter-variant
        </v-icon>
      </TextBtn>
    </template>
  </v-tooltip>
</template>
